export default __webpack_public_path__ + "static/media/tehdas_puhallus_360.20b6e5b4.jpg";